<div
  class="app-splash"
  [class.app-splash--fading]="fading"
  [class.app-splash--christmas]="theme === 'christmas'"
  [class.app-splash--easter]="theme === 'easter'"
  [class.app-splash--spring]="theme === 'spring'"
  [class.app-splash--summer]="theme === 'summer'"
  [class.app-splash--autumn]="theme === 'autumn'"
  [class.app-splash--winter]="theme === 'winter'"
  [class.app-splash--halloween]="theme === 'halloween'"
  [class.app-splash--bastille-day]="theme === 'bastille-day'"
  [class.app-splash--new-year]="theme === 'new-year'"
  [class.app-splash--april-fools]="theme === 'april-fools'"
>
  <div class="app-splash__particles">
    <ng-container *ngFor="let p of particles">

      <!-- ═══ SNOWFLAKE (christmas, winter) ═══ -->
      <div
        *ngIf="p.type === 'snowflake'"
        class="particle particle--snowflake"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <line x1="16" y1="2" x2="16" y2="30" stroke="white" stroke-width="1.5" opacity="0.8"/>
          <line x1="2" y1="16" x2="30" y2="16" stroke="white" stroke-width="1.5" opacity="0.8"/>
          <line x1="6" y1="6" x2="26" y2="26" stroke="white" stroke-width="1.2" opacity="0.6"/>
          <line x1="26" y1="6" x2="6" y2="26" stroke="white" stroke-width="1.2" opacity="0.6"/>
          <line x1="16" y1="6" x2="12" y2="2" stroke="white" stroke-width="1" opacity="0.5"/>
          <line x1="16" y1="6" x2="20" y2="2" stroke="white" stroke-width="1" opacity="0.5"/>
          <line x1="16" y1="26" x2="12" y2="30" stroke="white" stroke-width="1" opacity="0.5"/>
          <line x1="16" y1="26" x2="20" y2="30" stroke="white" stroke-width="1" opacity="0.5"/>
          <circle cx="16" cy="16" r="2" fill="white" opacity="0.9"/>
        </svg>
      </div>

      <!-- ═══ ORNAMENT (christmas) ═══ -->
      <div
        *ngIf="p.type === 'ornament'"
        class="particle particle--ornament"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.2"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 38" xmlns="http://www.w3.org/2000/svg">
          <rect x="13" y="0" width="6" height="4" rx="1" fill="#d4a843"/>
          <rect x="15" y="3" width="2" height="3" fill="#d4a843"/>
          <circle cx="16" cy="22" r="14" [attr.fill]="p.hue % 2 === 0 ? '#c0392b' : '#2e86c1'"/>
          <ellipse cx="11" cy="16" rx="3" ry="5" fill="white" opacity="0.2" transform="rotate(-20 11 16)"/>
          <path d="M4 18 Q16 14 28 18" fill="none" stroke="#d4a843" stroke-width="1.5" opacity="0.6"/>
          <path d="M4 26 Q16 30 28 26" fill="none" stroke="#d4a843" stroke-width="1.5" opacity="0.6"/>
        </svg>
      </div>

      <!-- ═══ CANDY CANE (christmas) ═══ -->
      <div
        *ngIf="p.type === 'candy-cane'"
        class="particle particle--candy-cane"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.6"
        [style.height.px]="p.size * 1.4"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 24 44" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 44 L8 12 Q8 2 16 2 Q24 2 24 10" fill="none" stroke="white" stroke-width="6" stroke-linecap="round"/>
          <path d="M8 44 L8 12 Q8 2 16 2 Q24 2 24 10" fill="none" stroke="#c0392b" stroke-width="6" stroke-linecap="round" stroke-dasharray="4 4"/>
        </svg>
      </div>

      <!-- ═══ STAR (christmas) ═══ -->
      <div
        *ngIf="p.type === 'star'"
        class="particle particle--star"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <polygon points="16,1 20,11 31,12 23,20 25,31 16,25 7,31 9,20 1,12 12,11" fill="#f1c40f"/>
          <polygon points="16,6 18.5,12.5 25.5,13 20.5,18 22,25 16,21 10,25 11.5,18 6.5,13 13.5,12.5" fill="#f7dc6f" opacity="0.5"/>
        </svg>
      </div>

      <!-- ═══ GIFT (christmas) ═══ -->
      <div
        *ngIf="p.type === 'gift'"
        class="particle particle--gift"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="8" width="32" height="6" rx="1" [attr.fill]="p.hue % 2 === 0 ? '#c0392b' : '#27ae60'"/>
          <rect x="4" y="14" width="28" height="18" rx="1" [attr.fill]="p.hue % 2 === 0 ? '#e74c3c' : '#2ecc71'"/>
          <rect x="15" y="8" width="6" height="24" fill="#f1c40f" opacity="0.8"/>
          <rect x="2" y="9" width="32" height="4" fill="#f1c40f" opacity="0.8"/>
          <ellipse cx="14" cy="6" rx="5" ry="4" fill="#f1c40f" transform="rotate(-15 14 6)"/>
          <ellipse cx="22" cy="6" rx="5" ry="4" fill="#f1c40f" transform="rotate(15 22 6)"/>
          <circle cx="18" cy="7" r="2.5" fill="#d4a843"/>
        </svg>
      </div>

      <!-- ═══ GINGERBREAD (christmas) ═══ -->
      <div
        *ngIf="p.type === 'gingerbread'"
        class="particle particle--gingerbread"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.2"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="8" r="7" fill="#c27a3a"/>
          <rect x="10" y="14" width="12" height="12" rx="2" fill="#c27a3a"/>
          <rect x="1" y="15" width="10" height="5" rx="2.5" fill="#c27a3a"/>
          <rect x="21" y="15" width="10" height="5" rx="2.5" fill="#c27a3a"/>
          <rect x="10" y="25" width="5" height="10" rx="2.5" fill="#c27a3a"/>
          <rect x="17" y="25" width="5" height="10" rx="2.5" fill="#c27a3a"/>
          <circle cx="13" cy="7" r="1.2" fill="#3a2a1a"/>
          <circle cx="19" cy="7" r="1.2" fill="#3a2a1a"/>
          <path d="M13 10 Q16 13 19 10" fill="none" stroke="#3a2a1a" stroke-width="0.8"/>
          <circle cx="16" cy="17" r="1.2" fill="#c0392b"/>
          <circle cx="16" cy="21" r="1.2" fill="#c0392b"/>
          <polygon points="13,14 16,15.5 19,14 16,17" fill="#27ae60"/>
          <path d="M1 17.5 Q3 16 5 17.5" fill="none" stroke="white" stroke-width="1" opacity="0.7"/>
          <path d="M27 17.5 Q29 16 31 17.5" fill="none" stroke="white" stroke-width="1" opacity="0.7"/>
        </svg>
      </div>

      <!-- ═══ EGG (easter) ═══ -->
      <div
        *ngIf="p.type === 'egg'"
        class="particle particle--egg"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.25"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 40" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="16" cy="22" rx="12" ry="16" [attr.fill]="'hsl(' + p.hue + ', 65%, 70%)'" />
          <path d="M6 16 Q11 13 16 16 Q21 19 26 16" fill="none" stroke="white" stroke-width="1.5" opacity="0.5"/>
          <path d="M6 22 Q11 25 16 22 Q21 19 26 22" fill="none" stroke="white" stroke-width="1.5" opacity="0.4"/>
          <path d="M8 28 Q16 31 24 28" fill="none" stroke="white" stroke-width="1.5" opacity="0.3"/>
          <circle cx="12" cy="18" r="1.5" fill="white" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ BUNNY (easter) ═══ -->
      <div
        *ngIf="p.type === 'bunny'"
        class="particle particle--bunny"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.4"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 50" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="13" cy="10" rx="4" ry="12" fill="#e8d5c4"/>
          <ellipse cx="13" cy="10" rx="2" ry="9" fill="#f0b8b8" opacity="0.5"/>
          <ellipse cx="23" cy="8" rx="4" ry="12" fill="#e8d5c4"/>
          <ellipse cx="23" cy="8" rx="2" ry="9" fill="#f0b8b8" opacity="0.5"/>
          <circle cx="18" cy="26" r="10" fill="#e8d5c4"/>
          <circle cx="14" cy="24" r="1.5" fill="#4a3728"/>
          <circle cx="22" cy="24" r="1.5" fill="#4a3728"/>
          <ellipse cx="18" cy="28" rx="1.5" ry="1" fill="#f0a0a0"/>
          <path d="M16 29.5 Q18 31.5 20 29.5" fill="none" stroke="#c08080" stroke-width="0.7"/>
          <line x1="8" y1="27" x2="14" y2="28" stroke="#c0a890" stroke-width="0.5"/>
          <line x1="8" y1="29" x2="14" y2="29" stroke="#c0a890" stroke-width="0.5"/>
          <line x1="22" y1="28" x2="28" y2="27" stroke="#c0a890" stroke-width="0.5"/>
          <line x1="22" y1="29" x2="28" y2="29" stroke="#c0a890" stroke-width="0.5"/>
          <ellipse cx="18" cy="40" rx="8" ry="7" fill="#e8d5c4"/>
          <circle cx="26" cy="42" r="3" fill="#f5ede5"/>
        </svg>
      </div>

      <!-- ═══ CHICK (easter) ═══ -->
      <div
        *ngIf="p.type === 'chick'"
        class="particle particle--chick"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.1"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 36" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="16" cy="24" rx="10" ry="9" fill="#ffe066"/>
          <circle cx="16" cy="13" r="8" fill="#ffe066"/>
          <circle cx="13" cy="12" r="1.5" fill="#3a2a1a"/>
          <circle cx="19" cy="12" r="1.5" fill="#3a2a1a"/>
          <polygon points="15,15 17,15 16,18" fill="#f0952a"/>
          <circle cx="10" cy="15" r="2" fill="#f0a0a0" opacity="0.3"/>
          <circle cx="22" cy="15" r="2" fill="#f0a0a0" opacity="0.3"/>
          <ellipse cx="7" cy="23" rx="4" ry="5" fill="#f5d44a" transform="rotate(-15 7 23)"/>
          <ellipse cx="25" cy="23" rx="4" ry="5" fill="#f5d44a" transform="rotate(15 25 23)"/>
          <path d="M12 32 L10 35 M12 32 L12 35 M12 32 L14 35" stroke="#f0952a" stroke-width="1" fill="none"/>
          <path d="M20 32 L18 35 M20 32 L20 35 M20 32 L22 35" stroke="#f0952a" stroke-width="1" fill="none"/>
        </svg>
      </div>

      <!-- ═══ FLOWER (easter, spring) ═══ -->
      <div
        *ngIf="p.type === 'flower'"
        class="particle particle--flower"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="16" cy="8" rx="5" ry="7" [attr.fill]="'hsl(' + p.hue + ', 70%, 75%)'" opacity="0.85"/>
          <ellipse cx="8" cy="14" rx="5" ry="7" transform="rotate(-60 8 14)" [attr.fill]="'hsl(' + ((p.hue + 20) % 360) + ', 70%, 75%)'" opacity="0.85"/>
          <ellipse cx="24" cy="14" rx="5" ry="7" transform="rotate(60 24 14)" [attr.fill]="'hsl(' + ((p.hue + 40) % 360) + ', 70%, 75%)'" opacity="0.85"/>
          <ellipse cx="10" cy="22" rx="5" ry="7" transform="rotate(-30 10 22)" [attr.fill]="'hsl(' + ((p.hue + 10) % 360) + ', 70%, 75%)'" opacity="0.85"/>
          <ellipse cx="22" cy="22" rx="5" ry="7" transform="rotate(30 22 22)" [attr.fill]="'hsl(' + ((p.hue + 30) % 360) + ', 70%, 75%)'" opacity="0.85"/>
          <circle cx="16" cy="16" r="4" fill="#ffe066"/>
        </svg>
      </div>

      <!-- ═══ BUTTERFLY (easter, spring) ═══ -->
      <div
        *ngIf="p.type === 'butterfly'"
        class="particle particle--butterfly"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.8"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 40 32" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="12" cy="10" rx="9" ry="7" [attr.fill]="'hsl(' + p.hue + ', 60%, 70%)'" opacity="0.8">
            <animateTransform attributeName="transform" type="rotate" values="-10 12 16;10 12 16;-10 12 16" dur="0.4s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="10" cy="22" rx="7" ry="6" [attr.fill]="'hsl(' + ((p.hue + 30) % 360) + ', 55%, 75%)'" opacity="0.7">
            <animateTransform attributeName="transform" type="rotate" values="10 10 16;-10 10 16;10 10 16" dur="0.4s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="28" cy="10" rx="9" ry="7" [attr.fill]="'hsl(' + p.hue + ', 60%, 70%)'" opacity="0.8">
            <animateTransform attributeName="transform" type="rotate" values="10 28 16;-10 28 16;10 28 16" dur="0.4s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="30" cy="22" rx="7" ry="6" [attr.fill]="'hsl(' + ((p.hue + 30) % 360) + ', 55%, 75%)'" opacity="0.7">
            <animateTransform attributeName="transform" type="rotate" values="-10 30 16;10 30 16;-10 30 16" dur="0.4s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="20" cy="16" rx="2" ry="10" fill="#5a4030"/>
          <path d="M19 7 Q15 2 12 1" fill="none" stroke="#5a4030" stroke-width="0.8"/>
          <circle cx="12" cy="1" r="1" fill="#5a4030"/>
          <path d="M21 7 Q25 2 28 1" fill="none" stroke="#5a4030" stroke-width="0.8"/>
          <circle cx="28" cy="1" r="1" fill="#5a4030"/>
        </svg>
      </div>

      <!-- ═══ CHERRY BLOSSOM (spring) ═══ -->
      <div
        *ngIf="p.type === 'cherry-blossom'"
        class="particle particle--cherry-blossom"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="16" cy="7" rx="4.5" ry="6.5" fill="#f8c8d8" transform="rotate(0 16 16)"/>
          <ellipse cx="16" cy="7" rx="4.5" ry="6.5" fill="#f0b0c8" transform="rotate(72 16 16)"/>
          <ellipse cx="16" cy="7" rx="4.5" ry="6.5" fill="#f8c8d8" transform="rotate(144 16 16)"/>
          <ellipse cx="16" cy="7" rx="4.5" ry="6.5" fill="#f0b0c8" transform="rotate(216 16 16)"/>
          <ellipse cx="16" cy="7" rx="4.5" ry="6.5" fill="#f8c8d8" transform="rotate(288 16 16)"/>
          <circle cx="16" cy="16" r="3" fill="#f5e0a0"/>
          <circle cx="15" cy="15" r="0.8" fill="#e8c060" opacity="0.6"/>
          <circle cx="17" cy="16.5" r="0.6" fill="#e8c060" opacity="0.5"/>
        </svg>
      </div>

      <!-- ═══ TULIP (spring) ═══ -->
      <div
        *ngIf="p.type === 'tulip'"
        class="particle particle--tulip"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.4"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 28 40" xmlns="http://www.w3.org/2000/svg">
          <line x1="14" y1="18" x2="14" y2="38" stroke="#4a9e5c" stroke-width="2.5"/>
          <path d="M14 28 Q6 24 8 30" fill="#5ab06a" stroke="none"/>
          <path d="M14 24 Q22 20 20 26" fill="#5ab06a" stroke="none"/>
          <ellipse cx="9" cy="12" rx="6" ry="12" [attr.fill]="'hsl(' + p.hue + ', 70%, 60%)'" transform="rotate(-10 9 12)"/>
          <ellipse cx="19" cy="12" rx="6" ry="12" [attr.fill]="'hsl(' + ((p.hue + 15) % 360) + ', 70%, 65%)'" transform="rotate(10 19 12)"/>
          <ellipse cx="14" cy="10" rx="5" ry="11" [attr.fill]="'hsl(' + ((p.hue + 8) % 360) + ', 65%, 55%)'" />
        </svg>
      </div>

      <!-- ═══ BEE (spring) ═══ -->
      <div
        *ngIf="p.type === 'bee'"
        class="particle particle--bee"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.9"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 32" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="10" cy="10" rx="7" ry="5" fill="rgba(255,255,255,0.5)" transform="rotate(-30 10 10)">
            <animateTransform attributeName="transform" type="rotate" values="-40 10 10;-20 10 10;-40 10 10" dur="0.15s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="26" cy="10" rx="7" ry="5" fill="rgba(255,255,255,0.5)" transform="rotate(30 26 10)">
            <animateTransform attributeName="transform" type="rotate" values="40 26 10;20 26 10;40 26 10" dur="0.15s" repeatCount="indefinite"/>
          </ellipse>
          <ellipse cx="18" cy="20" rx="10" ry="8" fill="#f5c518"/>
          <rect x="11" y="16" width="14" height="3" fill="#2c2c2c" rx="1"/>
          <rect x="11" y="22" width="14" height="3" fill="#2c2c2c" rx="1"/>
          <circle cx="14" cy="14" r="1.5" fill="#2c2c2c"/>
          <circle cx="22" cy="14" r="1.5" fill="#2c2c2c"/>
          <path d="M16 28 Q18 31 20 28" fill="none" stroke="#2c2c2c" stroke-width="0.8"/>
          <ellipse cx="18" cy="29" rx="3" ry="2" fill="#1a1a1a" opacity="0.7"/>
        </svg>
      </div>

      <!-- ═══ RAINDROP (spring) ═══ -->
      <div
        *ngIf="p.type === 'raindrop'"
        class="particle particle--raindrop"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.5"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 16 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 0 Q0 14 8 22 Q16 14 8 0Z" fill="#7cb9e8" opacity="0.6"/>
          <path d="M8 2 Q3 14 8 20" fill="none" stroke="white" stroke-width="1" opacity="0.3"/>
        </svg>
      </div>

      <!-- ═══ DAISY (spring) ═══ -->
      <div
        *ngIf="p.type === 'daisy'"
        class="particle particle--daisy"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <!-- Petals -->
          <ellipse cx="16" cy="6" rx="3.5" ry="6" fill="white"/>
          <ellipse cx="16" cy="26" rx="3.5" ry="6" fill="white"/>
          <ellipse cx="6" cy="16" rx="6" ry="3.5" fill="white"/>
          <ellipse cx="26" cy="16" rx="6" ry="3.5" fill="white"/>
          <ellipse cx="9" cy="9" rx="3.5" ry="6" fill="white" transform="rotate(45 9 9)"/>
          <ellipse cx="23" cy="9" rx="3.5" ry="6" fill="white" transform="rotate(-45 23 9)"/>
          <ellipse cx="9" cy="23" rx="3.5" ry="6" fill="white" transform="rotate(-45 9 23)"/>
          <ellipse cx="23" cy="23" rx="3.5" ry="6" fill="white" transform="rotate(45 23 23)"/>
          <!-- Center -->
          <circle cx="16" cy="16" r="5" fill="#f9d71c"/>
          <circle cx="15" cy="15" r="1" fill="#e8b830" opacity="0.5"/>
        </svg>
      </div>

      <!-- ═══ SUNFLOWER (spring) ═══ -->
      <div
        *ngIf="p.type === 'sunflower'"
        class="particle particle--sunflower"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.3"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 42" xmlns="http://www.w3.org/2000/svg">
          <!-- Stem -->
          <line x1="16" y1="22" x2="16" y2="40" stroke="#4a9e5c" stroke-width="2"/>
          <!-- Leaf -->
          <path d="M16 32 Q22 28 20 34" fill="#4a9e5c"/>
          <!-- Petals -->
          <ellipse cx="16" cy="6" rx="3" ry="6" fill="#f1c40f"/>
          <ellipse cx="16" cy="24" rx="3" ry="6" fill="#f1c40f"/>
          <ellipse cx="6" cy="15" rx="6" ry="3" fill="#f1c40f"/>
          <ellipse cx="26" cy="15" rx="6" ry="3" fill="#f1c40f"/>
          <ellipse cx="9" cy="8" rx="3" ry="5.5" fill="#f9d71c" transform="rotate(45 9 8)"/>
          <ellipse cx="23" cy="8" rx="3" ry="5.5" fill="#f9d71c" transform="rotate(-45 23 8)"/>
          <ellipse cx="9" cy="22" rx="3" ry="5.5" fill="#f9d71c" transform="rotate(-45 9 22)"/>
          <ellipse cx="23" cy="22" rx="3" ry="5.5" fill="#f9d71c" transform="rotate(45 23 22)"/>
          <!-- Center -->
          <circle cx="16" cy="15" r="6" fill="#5c3d11"/>
          <circle cx="14" cy="13" r="1" fill="#8a6030" opacity="0.5"/>
          <circle cx="18" cy="14" r="0.8" fill="#8a6030" opacity="0.4"/>
          <circle cx="16" cy="17" r="0.9" fill="#8a6030" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ LAVENDER (spring) ═══ -->
      <div
        *ngIf="p.type === 'lavender'"
        class="particle particle--lavender"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.5"
        [style.height.px]="p.size * 1.6"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 14 48" xmlns="http://www.w3.org/2000/svg">
          <!-- Stem -->
          <line x1="7" y1="18" x2="7" y2="46" stroke="#4a9e5c" stroke-width="1.5"/>
          <!-- Leaf -->
          <path d="M7 36 Q11 32 10 38" fill="#4a9e5c"/>
          <path d="M7 40 Q3 36 4 42" fill="#4a9e5c"/>
          <!-- Flower buds -->
          <ellipse cx="7" cy="6" rx="3" ry="3.5" fill="#9b59b6"/>
          <ellipse cx="7" cy="12" rx="3.5" ry="3" fill="#8e44ad"/>
          <ellipse cx="7" cy="18" rx="3" ry="3" fill="#a569bd"/>
          <ellipse cx="7" cy="24" rx="2.5" ry="2.5" fill="#bb8fce" opacity="0.8"/>
          <!-- Tiny highlights -->
          <circle cx="6" cy="5" r="0.8" fill="white" opacity="0.3"/>
          <circle cx="6" cy="11" r="0.8" fill="white" opacity="0.3"/>
        </svg>
      </div>

      <!-- ═══ SUN (summer) ═══ -->
      <div
        *ngIf="p.type === 'sun'"
        class="particle particle--sun"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
          <circle cx="18" cy="18" r="8" fill="#f9d71c"/>
          <circle cx="18" cy="18" r="6" fill="#fbe555" opacity="0.6"/>
          <line x1="18" y1="2" x2="18" y2="8" stroke="#f9d71c" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="18" y1="28" x2="18" y2="34" stroke="#f9d71c" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="2" y1="18" x2="8" y2="18" stroke="#f9d71c" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="28" y1="18" x2="34" y2="18" stroke="#f9d71c" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="6.7" y1="6.7" x2="10.9" y2="10.9" stroke="#f9d71c" stroke-width="2" stroke-linecap="round"/>
          <line x1="25.1" y1="25.1" x2="29.3" y2="29.3" stroke="#f9d71c" stroke-width="2" stroke-linecap="round"/>
          <line x1="6.7" y1="29.3" x2="10.9" y2="25.1" stroke="#f9d71c" stroke-width="2" stroke-linecap="round"/>
          <line x1="25.1" y1="10.9" x2="29.3" y2="6.7" stroke="#f9d71c" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>

      <!-- ═══ WAVE (summer) ═══ -->
      <div
        *ngIf="p.type === 'wave'"
        class="particle particle--wave"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.5"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 40 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 10 Q5 2 10 10 Q15 18 20 10 Q25 2 30 10 Q35 18 40 10" fill="none" stroke="#4fc3f7" stroke-width="3" opacity="0.6"/>
          <path d="M0 14 Q5 6 10 14 Q15 22 20 14 Q25 6 30 14 Q35 22 40 14" fill="none" stroke="#29b6f6" stroke-width="2" opacity="0.3"/>
        </svg>
      </div>

      <!-- ═══ PALM LEAF (summer) ═══ -->
      <div
        *ngIf="p.type === 'palm-leaf'"
        class="particle particle--palm-leaf"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.2"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 30 36" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 36 L15 12" stroke="#5a9e4b" stroke-width="2"/>
          <path d="M15 12 Q5 4 2 8 Q8 6 15 16" fill="#6ab854"/>
          <path d="M15 12 Q25 4 28 8 Q22 6 15 16" fill="#5a9e4b"/>
          <path d="M15 16 Q3 10 1 15 Q7 12 15 20" fill="#6ab854" opacity="0.9"/>
          <path d="M15 16 Q27 10 29 15 Q23 12 15 20" fill="#5a9e4b" opacity="0.9"/>
          <path d="M15 20 Q5 16 3 20 Q9 18 15 24" fill="#6ab854" opacity="0.8"/>
          <path d="M15 20 Q25 16 27 20 Q21 18 15 24" fill="#5a9e4b" opacity="0.8"/>
        </svg>
      </div>

      <!-- ═══ SEASHELL (summer) ═══ -->
      <div
        *ngIf="p.type === 'seashell'"
        class="particle particle--seashell"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 4 Q28 8 28 20 Q28 28 16 30 Q4 28 4 20 Q4 8 16 4Z" fill="#f5deb3"/>
          <path d="M16 4 Q16 16 16 30" fill="none" stroke="#d4b896" stroke-width="0.8"/>
          <path d="M16 6 Q22 12 24 20" fill="none" stroke="#d4b896" stroke-width="0.6" opacity="0.6"/>
          <path d="M16 6 Q10 12 8 20" fill="none" stroke="#d4b896" stroke-width="0.6" opacity="0.6"/>
          <path d="M16 10 Q25 16 26 24" fill="none" stroke="#d4b896" stroke-width="0.5" opacity="0.4"/>
          <path d="M16 10 Q7 16 6 24" fill="none" stroke="#d4b896" stroke-width="0.5" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ ICE CREAM (summer) ═══ -->
      <div
        *ngIf="p.type === 'ice-cream'"
        class="particle particle--ice-cream"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.4"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 28 40" xmlns="http://www.w3.org/2000/svg">
          <polygon points="8,20 20,20 14,38" fill="#d4a843"/>
          <line x1="9" y1="22" x2="13" y2="36" stroke="#c49530" stroke-width="0.5" opacity="0.5"/>
          <line x1="19" y1="22" x2="15" y2="36" stroke="#c49530" stroke-width="0.5" opacity="0.5"/>
          <circle cx="14" cy="14" r="8" [attr.fill]="'hsl(' + p.hue + ', 60%, 75%)'"/>
          <circle cx="8" cy="10" r="6" [attr.fill]="'hsl(' + ((p.hue + 40) % 360) + ', 55%, 80%)'"/>
          <circle cx="20" cy="10" r="6" [attr.fill]="'hsl(' + ((p.hue + 80) % 360) + ', 50%, 70%)'"/>
          <circle cx="11" cy="8" r="1" fill="white" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ BEACH BALL (summer) ═══ -->
      <div
        *ngIf="p.type === 'beach-ball'"
        class="particle particle--beach-ball"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="14" fill="#0077b6"/>
          <path d="M16 2 A14 14 0 0 1 30 16" fill="#e74c3c"/>
          <path d="M30 16 A14 14 0 0 1 16 30" fill="#f1c40f"/>
          <path d="M16 30 A14 14 0 0 1 2 16" fill="white"/>
          <!-- Cross lines -->
          <line x1="16" y1="2" x2="16" y2="30" stroke="white" stroke-width="0.8" opacity="0.5"/>
          <line x1="2" y1="16" x2="30" y2="16" stroke="white" stroke-width="0.8" opacity="0.5"/>
          <!-- Shine -->
          <ellipse cx="11" cy="10" rx="3" ry="4" fill="white" opacity="0.25" transform="rotate(-20 11 10)"/>
        </svg>
      </div>

      <!-- ═══ SURFBOARD (summer) ═══ -->
      <div
        *ngIf="p.type === 'surfboard'"
        class="particle particle--surfboard"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.5"
        [style.height.px]="p.size * 1.6"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 16 50" xmlns="http://www.w3.org/2000/svg">
          <!-- Board body -->
          <path d="M8 2 Q14 8 14 25 Q14 42 8 48 Q2 42 2 25 Q2 8 8 2Z"
            [attr.fill]="p.hue % 3 === 0 ? '#00b4d8' : p.hue % 3 === 1 ? '#0077b6' : '#48cae4'"/>
          <!-- Stripe -->
          <path d="M8 6 Q12 10 12 25 Q12 40 8 44" fill="none" stroke="white" stroke-width="1.2" opacity="0.5"/>
          <!-- Fin -->
          <path d="M8 40 L10 45 L6 45 Z" fill="#023e58" opacity="0.7"/>
          <!-- Stringer line -->
          <line x1="8" y1="4" x2="8" y2="46" stroke="white" stroke-width="0.5" opacity="0.3"/>
        </svg>
      </div>

      <!-- ═══ BEACH TOWEL (summer) ═══ -->
      <div
        *ngIf="p.type === 'beach-towel'"
        class="particle particle--beach-towel"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.7"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg">
          <!-- Towel body -->
          <rect x="2" y="2" width="32" height="20" rx="2" ry="2"
            [attr.fill]="p.hue % 4 === 0 ? '#0077b6' : p.hue % 4 === 1 ? '#00b4d8' : p.hue % 4 === 2 ? '#48cae4' : '#90e0ef'"/>
          <!-- Stripes -->
          <rect x="2" y="5" width="32" height="3" fill="white" opacity="0.35"/>
          <rect x="2" y="12" width="32" height="3" fill="white" opacity="0.35"/>
          <rect x="2" y="19" width="32" height="2" fill="white" opacity="0.25"/>
          <!-- Fringe at ends -->
          <line x1="4" y1="22" x2="4" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="8" y1="22" x2="8" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="12" y1="22" x2="12" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="16" y1="22" x2="16" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="20" y1="22" x2="20" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="24" y1="22" x2="24" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="28" y1="22" x2="28" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="32" y1="22" x2="32" y2="24" stroke="white" stroke-width="0.8" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ SUNGLASSES (summer) ═══ -->
      <div
        *ngIf="p.type === 'sunglasses'"
        class="particle particle--sunglasses"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.55"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 40 20" xmlns="http://www.w3.org/2000/svg">
          <!-- Bridge -->
          <path d="M15 8 Q20 5 25 8" fill="none" stroke="#1a1a2e" stroke-width="1.5" stroke-linecap="round"/>
          <!-- Left lens -->
          <rect x="2" y="6" width="13" height="10" rx="3" ry="3" fill="#0077b6" opacity="0.8"/>
          <rect x="2" y="6" width="13" height="10" rx="3" ry="3" fill="none" stroke="#1a1a2e" stroke-width="1.5"/>
          <!-- Right lens -->
          <rect x="25" y="6" width="13" height="10" rx="3" ry="3" fill="#0077b6" opacity="0.8"/>
          <rect x="25" y="6" width="13" height="10" rx="3" ry="3" fill="none" stroke="#1a1a2e" stroke-width="1.5"/>
          <!-- Arms -->
          <line x1="2" y1="9" x2="0" y2="7" stroke="#1a1a2e" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="38" y1="9" x2="40" y2="7" stroke="#1a1a2e" stroke-width="1.5" stroke-linecap="round"/>
          <!-- Lens shine -->
          <line x1="5" y1="9" x2="7" y2="9" stroke="white" stroke-width="1" opacity="0.5" stroke-linecap="round"/>
          <line x1="28" y1="9" x2="30" y2="9" stroke="white" stroke-width="1" opacity="0.5" stroke-linecap="round"/>
        </svg>
      </div>

      <!-- ═══ MAPLE LEAF (autumn) ═══ -->
      <div
        *ngIf="p.type === 'maple-leaf'"
        class="particle particle--maple-leaf"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 36" xmlns="http://www.w3.org/2000/svg">
          <line x1="16" y1="24" x2="16" y2="35" stroke="#8B6914" stroke-width="1.5"/>
          <path d="M16 2 L18 8 L24 6 L20 12 L28 14 L22 17 L26 22 L19 20 L16 26 L13 20 L6 22 L10 17 L4 14 L12 12 L8 6 L14 8 Z"
            [attr.fill]="p.hue % 3 === 0 ? '#e25822' : p.hue % 3 === 1 ? '#d4a017' : '#c0392b'" />
          <path d="M16 4 L16 24" fill="none" [attr.stroke]="p.hue % 3 === 0 ? '#c04018' : '#b08010'" stroke-width="0.6" opacity="0.5"/>
        </svg>
      </div>

      <!-- ═══ ACORN (autumn) ═══ -->
      <div
        *ngIf="p.type === 'acorn'"
        class="particle particle--acorn"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.3"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg">
          <line x1="12" y1="0" x2="12" y2="5" stroke="#6b4423" stroke-width="1.5"/>
          <path d="M4 8 Q4 4 12 4 Q20 4 20 8 L20 12 L4 12 Z" fill="#8B6914"/>
          <rect x="4" y="10" width="16" height="3" fill="#7a5c12" rx="1"/>
          <ellipse cx="12" cy="22" rx="9" ry="10" fill="#a0622e"/>
          <ellipse cx="12" cy="22" rx="9" ry="10" fill="none" stroke="#8a5222" stroke-width="0.6"/>
          <ellipse cx="10" cy="18" rx="2" ry="3" fill="#b07030" opacity="0.4" transform="rotate(-10 10 18)"/>
        </svg>
      </div>

      <!-- ═══ MUSHROOM (autumn) ═══ -->
      <div
        *ngIf="p.type === 'mushroom'"
        class="particle particle--mushroom"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.1"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 36" xmlns="http://www.w3.org/2000/svg">
          <rect x="12" y="18" width="8" height="14" rx="2" fill="#f0e6d0"/>
          <path d="M2 18 Q2 4 16 4 Q30 4 30 18 Z" fill="#c0392b"/>
          <circle cx="10" cy="10" r="2.5" fill="white" opacity="0.8"/>
          <circle cx="20" cy="8" r="2" fill="white" opacity="0.8"/>
          <circle cx="16" cy="14" r="1.8" fill="white" opacity="0.8"/>
          <circle cx="24" cy="14" r="1.5" fill="white" opacity="0.6"/>
          <circle cx="7" cy="15" r="1.5" fill="white" opacity="0.6"/>
          <path d="M12 32 Q10 34 8 32" fill="none" stroke="#a0d0a0" stroke-width="1"/>
          <path d="M20 32 Q22 34 24 32" fill="none" stroke="#a0d0a0" stroke-width="1"/>
        </svg>
      </div>

      <!-- ═══ PUMPKIN (autumn) ═══ -->
      <div
        *ngIf="p.type === 'pumpkin'"
        class="particle particle--pumpkin"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.9"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 34" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 2 Q16 0 18 4" fill="none" stroke="#4a8a3c" stroke-width="2" stroke-linecap="round"/>
          <path d="M18 4 Q10 2 8 4 Q2 8 4 18 Q6 30 18 30 Q30 30 32 18 Q34 8 28 4 Q26 2 18 4Z" fill="#e67e22"/>
          <path d="M18 4 Q18 16 18 30" fill="none" stroke="#d35400" stroke-width="0.8" opacity="0.4"/>
          <path d="M11 6 Q7 14 11 28" fill="none" stroke="#d35400" stroke-width="0.6" opacity="0.3"/>
          <path d="M25 6 Q29 14 25 28" fill="none" stroke="#d35400" stroke-width="0.6" opacity="0.3"/>
          <ellipse cx="14" cy="10" rx="3" ry="2" fill="#ea8c34" opacity="0.3" transform="rotate(-10 14 10)"/>
        </svg>
      </div>

      <!-- ═══ ICICLE (winter) ═══ -->
      <div
        *ngIf="p.type === 'icicle'"
        class="particle particle--icicle"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.5"
        [style.height.px]="p.size * 2"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 12 40" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 0 L2 4 Q0 8 2 12 Q4 16 2 20 Q0 26 3 32 L6 40 L9 32 Q12 26 10 20 Q8 16 10 12 Q12 8 10 4 L10 0 Z" fill="#d4eaf7" opacity="0.7"/>
          <path d="M4 2 Q3 10 4 18 Q5 26 6 38" fill="none" stroke="white" stroke-width="0.8" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ MITTEN (winter) ═══ -->
      <div
        *ngIf="p.type === 'mitten'"
        class="particle particle--mitten"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.1"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 28 32" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="0" width="20" height="6" rx="3" fill="#e74c3c" opacity="0.9"/>
          <path d="M4 6 L4 22 Q4 28 10 28 L18 28 Q24 28 24 22 L24 6 Z" [attr.fill]="p.hue % 2 === 0 ? '#e74c3c' : '#2e86c1'"/>
          <path d="M4 14 Q-2 12 -1 8 Q0 4 4 8" [attr.fill]="p.hue % 2 === 0 ? '#c0392b' : '#2471a3'"/>
          <path d="M6 8 L22 8" stroke="white" stroke-width="1" opacity="0.3"/>
          <path d="M6 10 L22 10" stroke="white" stroke-width="0.5" opacity="0.2"/>
          <circle cx="10" cy="18" r="1" fill="white" opacity="0.15"/>
          <circle cx="18" cy="20" r="1.2" fill="white" opacity="0.15"/>
          <circle cx="14" cy="16" r="0.8" fill="white" opacity="0.12"/>
        </svg>
      </div>

      <!-- ═══ PINECONE (winter) ═══ -->
      <div
        *ngIf="p.type === 'pinecone'"
        class="particle particle--pinecone"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.3"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg">
          <line x1="12" y1="0" x2="12" y2="4" stroke="#5a3e1b" stroke-width="2"/>
          <ellipse cx="12" cy="18" rx="9" ry="13" fill="#6b4423"/>
          <path d="M6 10 Q12 8 18 10" fill="none" stroke="#8a6030" stroke-width="1.5"/>
          <path d="M5 14 Q12 12 19 14" fill="none" stroke="#8a6030" stroke-width="1.5"/>
          <path d="M5 18 Q12 16 19 18" fill="none" stroke="#8a6030" stroke-width="1.5"/>
          <path d="M6 22 Q12 20 18 22" fill="none" stroke="#8a6030" stroke-width="1.5"/>
          <path d="M8 26 Q12 24 16 26" fill="none" stroke="#8a6030" stroke-width="1.5"/>
          <ellipse cx="10" cy="12" rx="1.5" ry="1" fill="#7a5020" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ SCARF (winter) ═══ -->
      <div
        *ngIf="p.type === 'scarf'"
        class="particle particle--scarf"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.6"
        [style.height.px]="p.size * 1.5"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 18 44" xmlns="http://www.w3.org/2000/svg">
          <!-- Scarf body -->
          <path d="M4 2 Q9 0 14 2 L14 34 Q12 36 10 34 L10 28 Q8 26 6 28 L6 34 Q4 36 4 34 Z"
            [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : p.hue % 3 === 1 ? '#2e86c1' : '#27ae60'"/>
          <!-- Stripes -->
          <rect x="4" y="8" width="10" height="2.5" fill="white" opacity="0.3"/>
          <rect x="4" y="16" width="10" height="2.5" fill="white" opacity="0.3"/>
          <rect x="4" y="24" width="10" height="2.5" fill="white" opacity="0.3"/>
          <!-- Fringe on left tail -->
          <line x1="4" y1="34" x2="4" y2="38" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="5.5" y1="34" x2="5.5" y2="39" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="7" y1="34" x2="7" y2="37" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <!-- Fringe on right tail -->
          <line x1="10" y1="34" x2="10" y2="38" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="11.5" y1="34" x2="11.5" y2="39" stroke="white" stroke-width="0.8" opacity="0.4"/>
          <line x1="13" y1="34" x2="13" y2="37" stroke="white" stroke-width="0.8" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ SKIS (winter) ═══ -->
      <div
        *ngIf="p.type === 'skis'"
        class="particle particle--skis"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.7"
        [style.height.px]="p.size * 1.8"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 22 52" xmlns="http://www.w3.org/2000/svg">
          <!-- Left ski -->
          <path d="M6 4 Q4 2 4 4 L4 46 Q4 50 6 50 L6 4Z" fill="#2e86c1"/>
          <path d="M4 4 Q4 2 6 2" fill="none" stroke="#2e86c1" stroke-width="1.5" stroke-linecap="round"/>
          <!-- Right ski -->
          <path d="M16 4 Q14 2 14 4 L14 46 Q14 50 16 50 L16 4Z" fill="#2e86c1"/>
          <path d="M14 4 Q14 2 16 2" fill="none" stroke="#2e86c1" stroke-width="1.5" stroke-linecap="round"/>
          <!-- Left pole -->
          <line x1="3" y1="8" x2="3" y2="44" stroke="#c0c0c0" stroke-width="1.2"/>
          <circle cx="3" cy="44" r="1.5" fill="none" stroke="#c0c0c0" stroke-width="0.8"/>
          <line x1="1" y1="8" x2="5" y2="8" stroke="#c0c0c0" stroke-width="1"/>
          <!-- Right pole -->
          <line x1="19" y1="8" x2="19" y2="44" stroke="#c0c0c0" stroke-width="1.2"/>
          <circle cx="19" cy="44" r="1.5" fill="none" stroke="#c0c0c0" stroke-width="0.8"/>
          <line x1="17" y1="8" x2="21" y2="8" stroke="#c0c0c0" stroke-width="1"/>
          <!-- Ski shine -->
          <line x1="5" y1="10" x2="5" y2="20" stroke="white" stroke-width="0.5" opacity="0.4"/>
          <line x1="15" y1="10" x2="15" y2="20" stroke="white" stroke-width="0.5" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ GLOVES (winter) ═══ -->
      <div
        *ngIf="p.type === 'gloves'"
        class="particle particle--gloves"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.1"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 28 32" xmlns="http://www.w3.org/2000/svg">
          <!-- Glove body -->
          <path d="M8 28 L8 14 Q8 10 12 10 L18 10 Q22 10 22 14 L22 28 Q22 30 18 30 L12 30 Q8 30 8 28Z"
            [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : p.hue % 3 === 1 ? '#2e86c1' : '#8e44ad'"/>
          <!-- Thumb -->
          <path d="M8 18 Q4 16 4 12 Q4 8 7 8 Q8 8 8 10"
            [attr.fill]="p.hue % 3 === 0 ? '#c0392b' : p.hue % 3 === 1 ? '#2471a3' : '#7d3c98'"/>
          <!-- Cuff -->
          <rect x="7" y="26" width="16" height="5" rx="1" fill="white" opacity="0.7"/>
          <!-- Cuff pattern -->
          <line x1="9" y1="28" x2="21" y2="28" stroke="white" stroke-width="0.6" opacity="0.3"/>
          <!-- Knit texture -->
          <path d="M10 16 Q12 14 14 16 Q16 14 18 16 Q20 14 22 16" fill="none"
            stroke="white" stroke-width="0.5" opacity="0.25"/>
          <path d="M10 20 Q12 18 14 20 Q16 18 18 20 Q20 18 22 20" fill="none"
            stroke="white" stroke-width="0.5" opacity="0.25"/>
        </svg>
      </div>

      <!-- ═══ CONFETTI (new-year) ═══ -->
      <div
        *ngIf="p.type === 'confetti'"
        class="particle particle--confetti"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.6"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="1" width="12" height="8" rx="1"
            [attr.fill]="p.hue % 5 === 0 ? '#e74c3c' : p.hue % 5 === 1 ? '#f1c40f' : p.hue % 5 === 2 ? '#2ecc71' : p.hue % 5 === 3 ? '#3498db' : '#9b59b6'"
            [attr.transform]="'rotate(' + (p.hue % 40 - 20) + ' 8 5)'"
          />
        </svg>
      </div>

      <!-- ═══ CHAMPAGNE (new-year) ═══ -->
      <div
        *ngIf="p.type === 'champagne'"
        class="particle particle--champagne"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.5"
        [style.height.px]="p.size * 1.5"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 18 44" xmlns="http://www.w3.org/2000/svg">
          <!-- Glass -->
          <path d="M5 18 L3 4 Q3 2 5 2 L13 2 Q15 2 15 4 L13 18 Z" fill="#f7e7a0" opacity="0.4"/>
          <path d="M5 18 L3 4 Q3 2 5 2 L13 2 Q15 2 15 4 L13 18 Z" fill="none" stroke="#d4a843" stroke-width="0.8"/>
          <!-- Bubbles -->
          <circle cx="8" cy="8" r="1" fill="white" opacity="0.6"/>
          <circle cx="11" cy="12" r="0.8" fill="white" opacity="0.5"/>
          <circle cx="7" cy="14" r="0.6" fill="white" opacity="0.4"/>
          <!-- Stem -->
          <rect x="8" y="18" width="2" height="14" fill="#d4a843"/>
          <!-- Base -->
          <ellipse cx="9" cy="34" rx="6" ry="2" fill="#d4a843"/>
          <!-- Fizz -->
          <circle cx="6" cy="0" r="1" fill="#f7e7a0" opacity="0.6"/>
          <circle cx="12" cy="-1" r="0.8" fill="#f7e7a0" opacity="0.5"/>
        </svg>
      </div>

      <!-- ═══ PARTY HAT (new-year) ═══ -->
      <div
        *ngIf="p.type === 'party-hat'"
        class="particle particle--party-hat"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.2"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 38" xmlns="http://www.w3.org/2000/svg">
          <!-- Cone -->
          <path d="M4 34 L16 4 L28 34 Z" [attr.fill]="p.hue % 2 === 0 ? '#e74c3c' : '#3498db'"/>
          <!-- Stripes -->
          <path d="M8 26 L16 10 L24 26" fill="none" stroke="#f1c40f" stroke-width="2" opacity="0.5"/>
          <path d="M6 30 L16 14 L26 30" fill="none" stroke="white" stroke-width="1.5" opacity="0.3"/>
          <!-- Dots -->
          <circle cx="12" cy="24" r="1.5" fill="white" opacity="0.5"/>
          <circle cx="20" cy="20" r="1.5" fill="#f1c40f" opacity="0.5"/>
          <circle cx="14" cy="16" r="1" fill="white" opacity="0.4"/>
          <!-- Pom-pom -->
          <circle cx="16" cy="4" r="3" fill="#f1c40f"/>
          <!-- Brim -->
          <ellipse cx="16" cy="34" rx="14" ry="3" fill="none" [attr.stroke]="p.hue % 2 === 0 ? '#c0392b' : '#2980b9'" stroke-width="1.5"/>
        </svg>
      </div>

      <!-- ═══ CLOCK (new-year) ═══ -->
      <div
        *ngIf="p.type === 'clock'"
        class="particle particle--clock"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="14" fill="#1a1a2e"/>
          <circle cx="16" cy="16" r="14" fill="none" stroke="#d4a843" stroke-width="1.5"/>
          <circle cx="16" cy="16" r="12" fill="none" stroke="#d4a843" stroke-width="0.5" opacity="0.3"/>
          <!-- Hour marks -->
          <line x1="16" y1="3" x2="16" y2="6" stroke="#d4a843" stroke-width="1.5"/>
          <line x1="16" y1="26" x2="16" y2="29" stroke="#d4a843" stroke-width="1.5"/>
          <line x1="3" y1="16" x2="6" y2="16" stroke="#d4a843" stroke-width="1.5"/>
          <line x1="26" y1="16" x2="29" y2="16" stroke="#d4a843" stroke-width="1.5"/>
          <!-- Hands pointing to midnight -->
          <line x1="16" y1="16" x2="16" y2="5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="16" y1="16" x2="16" y2="7" stroke="#d4a843" stroke-width="1" stroke-linecap="round"/>
          <!-- Center dot -->
          <circle cx="16" cy="16" r="1.5" fill="#d4a843"/>
        </svg>
      </div>

      <!-- ═══ FIREWORK BURST (new-year) ═══ -->
      <div
        *ngIf="p.type === 'firework-burst'"
        class="particle particle--firework-burst"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
          <circle cx="18" cy="18" r="2" [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : p.hue % 3 === 1 ? '#f1c40f' : '#3498db'"/>
          <line x1="18" y1="2" x2="18" y2="8" [attr.stroke]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="18" y1="28" x2="18" y2="34" [attr.stroke]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="2" y1="18" x2="8" y2="18" [attr.stroke]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="28" y1="18" x2="34" y2="18" [attr.stroke]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="7" y1="7" x2="11" y2="11" [attr.stroke]="p.hue % 3 === 2 ? '#3498db' : '#9b59b6'" stroke-width="1.2" stroke-linecap="round"/>
          <line x1="25" y1="25" x2="29" y2="29" [attr.stroke]="p.hue % 3 === 2 ? '#3498db' : '#9b59b6'" stroke-width="1.2" stroke-linecap="round"/>
          <line x1="7" y1="29" x2="11" y2="25" [attr.stroke]="p.hue % 3 === 2 ? '#3498db' : '#9b59b6'" stroke-width="1.2" stroke-linecap="round"/>
          <line x1="25" y1="11" x2="29" y2="7" [attr.stroke]="p.hue % 3 === 2 ? '#3498db' : '#9b59b6'" stroke-width="1.2" stroke-linecap="round"/>
          <circle cx="18" cy="2" r="1.5" [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'"/>
          <circle cx="18" cy="34" r="1.5" [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'"/>
          <circle cx="2" cy="18" r="1.5" [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'"/>
          <circle cx="34" cy="18" r="1.5" [attr.fill]="p.hue % 3 === 0 ? '#e74c3c' : '#f1c40f'"/>
        </svg>
      </div>

      <!-- ═══ JESTER HAT (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'jester-hat'"
        class="particle particle--jester-hat"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.1"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 40" xmlns="http://www.w3.org/2000/svg">
          <!-- Left horn -->
          <path d="M10 30 Q2 16 4 6" fill="#e74c3c"/>
          <circle cx="4" cy="6" r="3" fill="#f1c40f"/>
          <!-- Middle horn -->
          <path d="M18 30 Q18 12 18 2" fill="#2ecc71"/>
          <circle cx="18" cy="2" r="3" fill="#f1c40f"/>
          <!-- Right horn -->
          <path d="M26 30 Q34 16 32 6" fill="#3498db"/>
          <circle cx="32" cy="6" r="3" fill="#f1c40f"/>
          <!-- Band -->
          <path d="M4 28 Q10 34 18 30 Q26 34 32 28" fill="none" stroke="#f1c40f" stroke-width="3"/>
          <!-- Fill between horns -->
          <path d="M10 30 Q14 22 18 30 Q22 22 26 30" fill="#9b59b6" opacity="0.5"/>
        </svg>
      </div>

      <!-- ═══ QUESTION MARK (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'question-mark'"
        class="particle particle--question-mark"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.4"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 24 34" xmlns="http://www.w3.org/2000/svg">
          <text x="12" y="26" text-anchor="middle" font-size="30" font-weight="bold"
            [attr.fill]="p.hue % 4 === 0 ? '#e74c3c' : p.hue % 4 === 1 ? '#f1c40f' : p.hue % 4 === 2 ? '#2ecc71' : '#9b59b6'"
            font-family="Arial, sans-serif">?</text>
        </svg>
      </div>

      <!-- ═══ WHOOPEE CUSHION (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'whoopee'"
        class="particle particle--whoopee"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.7"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 22" xmlns="http://www.w3.org/2000/svg">
          <!-- Cushion body -->
          <ellipse cx="16" cy="14" rx="14" ry="8" fill="#e74c3c"/>
          <ellipse cx="16" cy="14" rx="14" ry="8" fill="none" stroke="#c0392b" stroke-width="0.8"/>
          <!-- Nozzle -->
          <rect x="14" y="2" width="4" height="6" rx="2" fill="#c0392b"/>
          <!-- Wrinkle lines -->
          <path d="M6 12 Q10 10 14 12" fill="none" stroke="#c0392b" stroke-width="0.6" opacity="0.5"/>
          <path d="M18 12 Q22 10 26 12" fill="none" stroke="#c0392b" stroke-width="0.6" opacity="0.5"/>
          <!-- Puff clouds -->
          <circle cx="10" cy="4" r="2" fill="#ddd" opacity="0.5"/>
          <circle cx="22" cy="2" r="1.5" fill="#ddd" opacity="0.4"/>
        </svg>
      </div>

      <!-- ═══ SPRING SNAKE (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'spring-snake'"
        class="particle particle--spring-snake"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.6"
        [style.height.px]="p.size * 1.6"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 18 48" xmlns="http://www.w3.org/2000/svg">
          <!-- Spring coils -->
          <path d="M4 46 Q14 44 14 40 Q14 36 4 34 Q-2 32 4 28 Q14 26 14 22 Q14 18 4 16 Q-2 14 4 10 Q14 8 14 4" fill="none" stroke="#2ecc71" stroke-width="3"/>
          <!-- Snake head -->
          <circle cx="14" cy="4" r="4" fill="#2ecc71"/>
          <circle cx="12" cy="3" r="1" fill="#1a1a2e"/>
          <circle cx="16" cy="3" r="1" fill="#1a1a2e"/>
          <path d="M13 6 Q14 8 15 6" fill="none" stroke="#c0392b" stroke-width="1"/>
          <!-- Tongue -->
          <path d="M14 7 L14 10 M14 10 L12 12 M14 10 L16 12" fill="none" stroke="#c0392b" stroke-width="0.8"/>
        </svg>
      </div>

      <!-- ═══ BANANA PEEL (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'banana-peel'"
        class="particle particle--banana-peel"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.8"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 26" xmlns="http://www.w3.org/2000/svg">
          <!-- Peel pieces splayed out -->
          <path d="M16 14 Q8 8 4 2" fill="none" stroke="#f1c40f" stroke-width="4" stroke-linecap="round"/>
          <path d="M16 14 Q24 8 28 2" fill="none" stroke="#f1c40f" stroke-width="4" stroke-linecap="round"/>
          <path d="M16 14 Q10 20 6 24" fill="none" stroke="#f1c40f" stroke-width="4" stroke-linecap="round"/>
          <path d="M16 14 Q22 20 26 24" fill="none" stroke="#f1c40f" stroke-width="4" stroke-linecap="round"/>
          <!-- Brown tips -->
          <circle cx="4" cy="2" r="1.5" fill="#8B6914"/>
          <circle cx="28" cy="2" r="1.5" fill="#8B6914"/>
          <!-- Center -->
          <circle cx="16" cy="14" r="3" fill="#e8c830"/>
        </svg>
      </div>

      <!-- ═══ JOY EMOJI (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'joy-emoji'"
        class="particle particle--joy-emoji"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <!-- Face -->
          <circle cx="16" cy="16" r="14" fill="#f9d71c"/>
          <circle cx="16" cy="16" r="14" fill="none" stroke="#e8c830" stroke-width="0.8"/>
          <!-- Closed happy eyes -->
          <path d="M8 14 Q10 10 14 14" fill="none" stroke="#1a1a2e" stroke-width="2" stroke-linecap="round"/>
          <path d="M18 14 Q20 10 24 14" fill="none" stroke="#1a1a2e" stroke-width="2" stroke-linecap="round"/>
          <!-- Big grin -->
          <path d="M8 18 Q16 28 24 18" fill="none" stroke="#1a1a2e" stroke-width="2"/>
          <path d="M8 18 Q16 26 24 18" fill="white"/>
          <!-- Tear drops of joy -->
          <path d="M6 16 Q4 20 6 22" fill="#4fc3f7" opacity="0.6"/>
          <path d="M26 16 Q28 20 26 22" fill="#4fc3f7" opacity="0.6"/>
        </svg>
      </div>

      <!-- ═══ FISH / POISSON D'AVRIL (april-fools) ═══ -->
      <div
        *ngIf="p.type === 'fish'"
        class="particle particle--fish"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 28" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <ellipse cx="20" cy="14" rx="12" ry="8" [attr.fill]="p.hue % 4 === 0 ? '#3498db' : p.hue % 4 === 1 ? '#e74c3c' : p.hue % 4 === 2 ? '#f1c40f' : '#2ecc71'"/>
          <!-- Tail -->
          <polygon points="8,14 2,6 2,22" [attr.fill]="p.hue % 4 === 0 ? '#2980b9' : p.hue % 4 === 1 ? '#c0392b' : p.hue % 4 === 2 ? '#d4ac0d' : '#27ae60'"/>
          <!-- Dorsal fin -->
          <path d="M18 6 Q22 2 26 6" [attr.fill]="p.hue % 4 === 0 ? '#2980b9' : p.hue % 4 === 1 ? '#c0392b' : p.hue % 4 === 2 ? '#d4ac0d' : '#27ae60'" opacity="0.8"/>
          <!-- Eye -->
          <circle cx="26" cy="12" r="2.5" fill="white"/>
          <circle cx="27" cy="11.5" r="1.2" fill="#1a1a2e"/>
          <!-- Scales hint -->
          <path d="M14 11 Q16 9 18 11 Q20 9 22 11" fill="none" stroke="white" stroke-width="0.6" opacity="0.4"/>
          <path d="M14 14 Q16 12 18 14 Q20 12 22 14" fill="none" stroke="white" stroke-width="0.6" opacity="0.4"/>
          <path d="M14 17 Q16 15 18 17 Q20 15 22 17" fill="none" stroke="white" stroke-width="0.6" opacity="0.4"/>
          <!-- Mouth -->
          <path d="M31 13.5 Q32 14 31 14.5" fill="none" stroke="#1a1a2e" stroke-width="0.8" stroke-linecap="round"/>
        </svg>
      </div>

      <!-- ═══ FIREWORK (bastille-day) ═══ -->
      <div
        *ngIf="p.type === 'firework'"
        class="particle particle--firework"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
          <circle cx="18" cy="18" r="3" [attr.fill]="p.hue % 3 === 0 ? '#002395' : p.hue % 3 === 1 ? '#ED2939' : 'white'"/>
          <line x1="18" y1="4" x2="18" y2="10" [attr.stroke]="p.hue % 3 === 0 ? '#002395' : '#ED2939'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="18" y1="26" x2="18" y2="32" [attr.stroke]="p.hue % 3 === 0 ? '#002395' : '#ED2939'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="4" y1="18" x2="10" y2="18" [attr.stroke]="p.hue % 3 === 0 ? '#002395' : '#ED2939'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="26" y1="18" x2="32" y2="18" [attr.stroke]="p.hue % 3 === 0 ? '#002395' : '#ED2939'" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="8" y1="8" x2="12" y2="12" stroke="#f1c40f" stroke-width="1.2" stroke-linecap="round"/>
          <line x1="24" y1="24" x2="28" y2="28" stroke="#f1c40f" stroke-width="1.2" stroke-linecap="round"/>
          <line x1="8" y1="28" x2="12" y2="24" stroke="#f1c40f" stroke-width="1.2" stroke-linecap="round"/>
          <line x1="24" y1="12" x2="28" y2="8" stroke="#f1c40f" stroke-width="1.2" stroke-linecap="round"/>
          <circle cx="18" cy="4" r="1.2" [attr.fill]="p.hue % 3 === 0 ? '#002395' : '#ED2939'"/>
          <circle cx="18" cy="32" r="1.2" [attr.fill]="p.hue % 3 === 0 ? '#002395' : '#ED2939'"/>
          <circle cx="4" cy="18" r="1.2" [attr.fill]="p.hue % 3 === 0 ? '#002395' : '#ED2939'"/>
          <circle cx="32" cy="18" r="1.2" [attr.fill]="p.hue % 3 === 0 ? '#002395' : '#ED2939'"/>
          <circle cx="8" cy="8" r="1" fill="#f1c40f"/>
          <circle cx="28" cy="28" r="1" fill="#f1c40f"/>
          <circle cx="8" cy="28" r="1" fill="#f1c40f"/>
          <circle cx="28" cy="8" r="1" fill="#f1c40f"/>
        </svg>
      </div>

      <!-- ═══ TRICOLOR FLAG (bastille-day) ═══ -->
      <div
        *ngIf="p.type === 'tricolor-flag'"
        class="particle particle--tricolor-flag"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.7"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg">
          <rect x="1" y="1" width="34" height="22" rx="1" fill="white" stroke="#ccc" stroke-width="0.5"/>
          <rect x="1" y="1" width="11.3" height="22" fill="#002395" rx="1"/>
          <rect x="23.7" y="1" width="11.3" height="22" fill="#ED2939" rx="1"/>
          <!-- Pole -->
          <line x1="1" y1="0" x2="1" y2="24" stroke="#888" stroke-width="1.5"/>
          <circle cx="1" cy="0" r="1.5" fill="#d4a843"/>
        </svg>
      </div>

      <!-- ═══ ROSETTE (bastille-day) ═══ -->
      <div
        *ngIf="p.type === 'rosette'"
        class="particle particle--rosette"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <!-- Outer ring (red) -->
          <circle cx="16" cy="16" r="14" fill="#ED2939"/>
          <!-- Middle ring (white) -->
          <circle cx="16" cy="16" r="10" fill="white"/>
          <!-- Inner circle (blue) -->
          <circle cx="16" cy="16" r="6" fill="#002395"/>
          <!-- Pleats -->
          <circle cx="16" cy="16" r="14" fill="none" stroke="#c0202f" stroke-width="0.5" stroke-dasharray="3 2"/>
          <!-- Ribbons -->
          <path d="M10 28 L8 36 L12 32" fill="#002395" opacity="0.7"/>
          <path d="M22 28 L24 36 L20 32" fill="#ED2939" opacity="0.7"/>
        </svg>
      </div>

      <!-- ═══ EIFFEL (bastille-day) ═══ -->
      <div
        *ngIf="p.type === 'eiffel'"
        class="particle particle--eiffel"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size * 0.6"
        [style.height.px]="p.size * 1.5"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 24 44" xmlns="http://www.w3.org/2000/svg">
          <!-- Tower silhouette -->
          <path d="M12 0 L11 4 L10 4 L8 16 L6 16 L4 28 L2 28 L0 40 L4 40 L5 36 L7 36 L8 28 L10 28 L11 16 L13 16 L14 28 L16 28 L17 36 L19 36 L20 40 L24 40 L22 28 L20 28 L18 16 L16 16 L14 4 L13 4 Z" fill="#5a5a6a"/>
          <!-- Platform lines -->
          <rect x="7" y="15" width="10" height="1.5" fill="#4a4a5a"/>
          <rect x="5" y="27" width="14" height="1.5" fill="#4a4a5a"/>
          <!-- Arch -->
          <path d="M6 38 Q12 32 18 38" fill="none" stroke="#4a4a5a" stroke-width="1"/>
          <!-- Antenna -->
          <line x1="12" y1="0" x2="12" y2="-2" stroke="#5a5a6a" stroke-width="1"/>
        </svg>
      </div>

      <!-- ═══ FLEUR-DE-LIS (bastille-day) ═══ -->
      <div
        *ngIf="p.type === 'fleur-de-lis'"
        class="particle particle--fleur-de-lis"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.2"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 28 34" xmlns="http://www.w3.org/2000/svg">
          <!-- Center petal -->
          <path d="M14 2 Q10 8 10 14 Q10 18 14 20 Q18 18 18 14 Q18 8 14 2Z" fill="#d4a843"/>
          <!-- Left petal -->
          <path d="M6 6 Q2 12 4 18 Q6 20 10 18 Q8 14 8 10 Q8 8 6 6Z" fill="#d4a843"/>
          <!-- Right petal -->
          <path d="M22 6 Q26 12 24 18 Q22 20 18 18 Q20 14 20 10 Q20 8 22 6Z" fill="#d4a843"/>
          <!-- Base band -->
          <rect x="6" y="20" width="16" height="3" rx="1" fill="#c09830"/>
          <!-- Stem -->
          <rect x="12" y="23" width="4" height="8" fill="#d4a843"/>
          <!-- Base -->
          <rect x="8" y="30" width="12" height="3" rx="1" fill="#c09830"/>
        </svg>
      </div>

      <!-- ═══ JACK-O-LANTERN (halloween) ═══ -->
      <div
        *ngIf="p.type === 'jack-o-lantern'"
        class="particle particle--jack-o-lantern"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.95"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 34" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 2 Q16 0 18 4" fill="none" stroke="#4a8a3c" stroke-width="2" stroke-linecap="round"/>
          <path d="M18 4 Q10 2 8 4 Q2 8 4 18 Q6 30 18 30 Q30 30 32 18 Q34 8 28 4 Q26 2 18 4Z" fill="#e67e22"/>
          <path d="M18 4 Q18 16 18 30" fill="none" stroke="#d35400" stroke-width="0.8" opacity="0.3"/>
          <!-- Eyes -->
          <polygon points="10,13 14,10 14,16" fill="#f9d71c"/>
          <polygon points="22,13 26,10 22,16" fill="#f9d71c"/>
          <!-- Nose -->
          <polygon points="18,16 16,20 20,20" fill="#f9d71c"/>
          <!-- Mouth -->
          <path d="M10 22 L12 24 L14 22 L16 24 L18 22 L20 24 L22 22 L24 24 L26 22" fill="none" stroke="#f9d71c" stroke-width="1.5"/>
          <!-- Glow -->
          <ellipse cx="18" cy="18" rx="10" ry="8" fill="#f9d71c" opacity="0.08"/>
        </svg>
      </div>

      <!-- ═══ GHOST (halloween) ═══ -->
      <div
        *ngIf="p.type === 'ghost'"
        class="particle particle--ghost"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.3"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 32 42" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 18 Q4 2 16 2 Q28 2 28 18 L28 36 L24 32 L20 36 L16 32 L12 36 L8 32 L4 36 Z" fill="white" opacity="0.85"/>
          <path d="M4 18 Q4 2 16 2 Q28 2 28 18 L28 36 L24 32 L20 36 L16 32 L12 36 L8 32 L4 36 Z" fill="none" stroke="#d0d0d0" stroke-width="0.5"/>
          <!-- Eyes -->
          <ellipse cx="12" cy="16" rx="3" ry="4" fill="#1a1a2e"/>
          <ellipse cx="20" cy="16" rx="3" ry="4" fill="#1a1a2e"/>
          <!-- Mouth -->
          <ellipse cx="16" cy="24" rx="3" ry="2.5" fill="#1a1a2e"/>
          <!-- Blush -->
          <circle cx="8" cy="20" r="2" fill="#d0a0d0" opacity="0.2"/>
          <circle cx="24" cy="20" r="2" fill="#d0a0d0" opacity="0.2"/>
        </svg>
      </div>

      <!-- ═══ BAT (halloween) ═══ -->
      <div
        *ngIf="p.type === 'bat'"
        class="particle particle--bat"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 0.6"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 44 26" xmlns="http://www.w3.org/2000/svg">
          <!-- Left wing -->
          <path d="M22 14 Q12 4 2 8 Q6 10 4 16 Q8 12 10 18 Q14 10 22 14Z" fill="#2c2040">
            <animateTransform attributeName="transform" type="rotate" values="-8 22 14;8 22 14;-8 22 14" dur="0.3s" repeatCount="indefinite"/>
          </path>
          <!-- Right wing -->
          <path d="M22 14 Q32 4 42 8 Q38 10 40 16 Q36 12 34 18 Q30 10 22 14Z" fill="#2c2040">
            <animateTransform attributeName="transform" type="rotate" values="8 22 14;-8 22 14;8 22 14" dur="0.3s" repeatCount="indefinite"/>
          </path>
          <!-- Body -->
          <ellipse cx="22" cy="14" rx="4" ry="5" fill="#1a1030"/>
          <!-- Ears -->
          <polygon points="19,10 18,5 21,9" fill="#1a1030"/>
          <polygon points="25,10 26,5 23,9" fill="#1a1030"/>
          <!-- Eyes -->
          <circle cx="20" cy="12" r="1" fill="#f9d71c"/>
          <circle cx="24" cy="12" r="1" fill="#f9d71c"/>
        </svg>
      </div>

      <!-- ═══ SPIDER (halloween) ═══ -->
      <div
        *ngIf="p.type === 'spider'"
        class="particle particle--spider"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.4"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 28 40" xmlns="http://www.w3.org/2000/svg">
          <!-- Thread -->
          <line x1="14" y1="0" x2="14" y2="14" stroke="#888" stroke-width="0.5" opacity="0.5"/>
          <!-- Body -->
          <ellipse cx="14" cy="22" rx="5" ry="7" fill="#1a1a2e"/>
          <circle cx="14" cy="15" r="4" fill="#1a1a2e"/>
          <!-- Eyes -->
          <circle cx="12" cy="14" r="1.2" fill="#c0392b"/>
          <circle cx="16" cy="14" r="1.2" fill="#c0392b"/>
          <circle cx="12.3" cy="13.7" r="0.4" fill="white"/>
          <circle cx="16.3" cy="13.7" r="0.4" fill="white"/>
          <!-- Legs (left) -->
          <path d="M10 16 Q4 12 2 8" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <path d="M10 18 Q3 16 1 14" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <path d="M10 22 Q3 22 1 20" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <path d="M10 26 Q4 28 2 32" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <!-- Legs (right) -->
          <path d="M18 16 Q24 12 26 8" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <path d="M18 18 Q25 16 27 14" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <path d="M18 22 Q25 22 27 20" fill="none" stroke="#1a1a2e" stroke-width="1"/>
          <path d="M18 26 Q24 28 26 32" fill="none" stroke="#1a1a2e" stroke-width="1"/>
        </svg>
      </div>

      <!-- ═══ CANDY CORN (halloween) ═══ -->
      <div
        *ngIf="p.type === 'candy-corn'"
        class="particle particle--candy-corn"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.6"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 0 Q2 10 2 18 Q2 24 8 26 Q14 24 14 18 Q14 10 8 0Z" fill="#f5f0e0"/>
          <path d="M8 8 Q3 14 3 18 Q3 24 8 26 Q13 24 13 18 Q13 14 8 8Z" fill="#e67e22"/>
          <path d="M8 16 Q4 20 4 22 Q4 25 8 26 Q12 25 12 22 Q12 20 8 16Z" fill="#f9d71c"/>
        </svg>
      </div>

      <!-- ═══ WITCH HAT (halloween) ═══ -->
      <div
        *ngIf="p.type === 'witch-hat'"
        class="particle particle--witch-hat"
        [style.left.%]="p.left"
        [style.animationDelay.s]="p.delay"
        [style.animationDuration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size * 1.1"
        [style.opacity]="p.opacity"
      >
        <svg viewBox="0 0 36 40" xmlns="http://www.w3.org/2000/svg">
          <!-- Brim -->
          <ellipse cx="18" cy="34" rx="17" ry="4" fill="#2c2040"/>
          <!-- Cone -->
          <path d="M8 34 L18 4 L28 34 Z" fill="#1a1030"/>
          <!-- Band -->
          <rect x="9" y="28" width="18" height="4" fill="#8e44ad" rx="1"/>
          <!-- Buckle -->
          <rect x="15" y="27" width="6" height="6" fill="#f1c40f" rx="1"/>
          <rect x="16.5" y="28.5" width="3" height="3" fill="#1a1030" rx="0.5"/>
          <!-- Tip bend -->
          <path d="M18 4 Q22 2 24 6" fill="none" stroke="#1a1030" stroke-width="2" stroke-linecap="round"/>
          <circle cx="24" cy="6" r="1.5" fill="#8e44ad"/>
        </svg>
      </div>

    </ng-container>
  </div>

  <div class="app-splash__logo">
    <div class="app-splash__logo-ring app-splash__logo-ring--outer"></div>
    <div class="app-splash__logo-ring"></div>
    <div class="app-splash__logo-icon">
      <svg width="120" height="121" viewBox="0 0 120 121" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M91.8874 119.94C81.9994 117.706 53.3133 105.984 34.4969 96.4885C15.16 86.7306 3.89204 78.5645 0.819638 72.0819C-0.44164 69.4207 -0.268267 67.433 1.48732 64.427C4.44327 59.3657 12.7636 51.288 24.0659 42.507C29.718 38.1156 41.7802 29.412 42.2139 29.412C42.3128 29.412 45.9793 33.3313 50.3617 38.1216L58.3298 46.8313L56.6673 48.8826C49.8128 57.3409 46.0623 63.7373 45.7521 67.4984C45.5565 69.8693 45.6469 70.0163 49.8701 74.1983C56.3253 80.5903 62.6623 86.3928 75.4553 97.6252C89.5446 109.996 94.5415 114.79 96.165 117.493C97.0162 118.911 97.1139 119.432 96.621 119.925C96.2857 120.26 95.9987 120.322 94.834 120.308C94.0708 120.299 92.7449 120.134 91.8874 119.94Z" fill="var(--splash-accent)"/>
        <path d="M94.8731 0.0340392C101.303 -0.764466 87.7182 12.5601 75.1797 26.9343C70.0046 23.8003 65.6855 20.554 60.8683 17.4389C75.9788 7.53673 90.5329 0.513261 94.8731 0.0340392Z" fill="var(--splash-accent)"/>
        <path d="M46.0318 113.926C49.24 112.516 49.7523 112.062 56.5038 109.187C51.1991 106.952 48.0026 105.656 41.8942 102.781C20.0321 121.148 19.1866 127.022 46.0318 113.926Z" fill="var(--splash-accent-muted)"/>
        <path d="M119.415 66.8343C119.576 58.8486 81.6398 33.9336 58.3307 18.1219C52.2656 20.995 48.1897 21.9205 43.528 27.3508C54.6367 39.2428 80.6403 65.9232 74.5595 70.9524C70.2193 75.2647 67.473 78.4027 62.4898 82.7152C68.2528 87.9212 73.3136 92.4388 78.8737 97.4213C99.6101 88.3178 119.255 75.6185 119.415 66.8343Z" fill="var(--splash-accent-muted)"/>
        <path d="M23.9305 0.234697C17.5006 -0.56382 30.9897 12.9773 43.5282 27.3515C48.5115 24.1573 53.5085 20.9975 58.331 18.1227C43.2205 8.22048 28.2707 0.713867 23.9305 0.234697Z" fill="var(--splash-accent-muted)"/>
      </svg>
    </div>
  </div>

  <div class="app-splash__brand">
    <h1 class="app-splash__title"><span class="app-splash__logo">Datach<span class="app-splash__logo-ai">[AI]</span>n</span><sup class="app-splash__logo-reg">&reg;</sup> <span class="app-splash__title-byline">by Adobis Group</span></h1>
    <p class="app-splash__subtitle">{{ subtitleText }}</p>
  </div>

  <div class="app-splash__progress">
    <div class="app-splash__progress-bar"></div>
  </div>
</div>
